import {
  AvailableProducts,
  DEDocumentType,
  DocumentType,
  TCustomerJourney,
} from '../../../Types';
import { TrackAmplitudeEventOptions } from '../Amplitude.types';

const EVENT_NAMES = {
  INTRODUCER_SIGNUP_STARTED: 'Introducer sign up started',
  INTRODUCER_SIGNUP_COMPLETED: 'Introducer sign up completed',
  APPLICATION_MODAL_OPENED: 'Application modal opened',
  APPLICATION_STARTED: 'Application started',
  OFFER_ACCEPTED: 'Offer accepted',
  DOCUMENT_UPLOAD_STARTED: 'Documents upload started',
  NOTIFICATION_SHOWN: 'Notification shown',
  NOTIFICATION_CTA_CLICKED: 'Notification CTA clicked',
  PAGE_VISITED: 'Introducer Portal Visited',
};

interface Category {
  INTRODUCER_SIGNUP: TCustomerJourney;
  INTRODUCER_SIGNUP_DE: TCustomerJourney;
  INTRODUCER_PORTAL: TCustomerJourney;
  INTRODUCER_PORTAL_DE: TCustomerJourney;
}

const CATEGORY: Category = {
  INTRODUCER_SIGNUP: 'Introducer signup',
  INTRODUCER_SIGNUP_DE: 'Introducer signup DE',
  INTRODUCER_PORTAL: 'Introducer portal',
  INTRODUCER_PORTAL_DE: 'Introducer portal DE',
};

const SUB_CATEGORY = {
  INTRODUCER_SIGNUP: 'Introducer sign up',
  INTRODUCER_SIGNUP_COMPLETE: 'Introducer sign up complete',
  APPLICATION_MODAL: 'Application modal',
  MAIN_PORTAL: 'Main portal',
};

/**
 * @deprecated
 */
export const TRACK_INTRODUCER_SIGNUP_STARTED = {
  event: EVENT_NAMES.INTRODUCER_SIGNUP_STARTED,
  category: CATEGORY.INTRODUCER_SIGNUP as TCustomerJourney,
  subCategory: SUB_CATEGORY.INTRODUCER_SIGNUP,
};

/**
 * @deprecated
 */
export function getIntroducerSignupStartedEventDetails({
  signupType,
  source,
  locale,
}: {
  locale: string;
  signupType: ['standard', 'invite'];
  source?: string;
}): TrackAmplitudeEventOptions {
  return {
    event: EVENT_NAMES.INTRODUCER_SIGNUP_STARTED,
    category: getIntroducerPortalSignupCategoryfromLocale(locale),
    payload: {
      signupType,
      source: source,
    },
  };
}

/**
 * @deprecated
 */
export function getIntroducerSignupCompleteEventDetails({
  introducerType,
  source,
  locale,
}: {
  introducerType: ['broker', 'accountant', 'other'];
  locale: string;
  source?: string;
}): TrackAmplitudeEventOptions {
  return {
    event: EVENT_NAMES.INTRODUCER_SIGNUP_COMPLETED,
    category: getIntroducerPortalSignupCategoryfromLocale(locale),

    payload: {
      introducerType: introducerType,
      source: source,
    },
  };
}

/**
 * @deprecated
 */
export function getStepZeroModalOpenedEventDetails({
  source,
  locale,
}: {
  locale: string;
  source?: string;
}): TrackAmplitudeEventOptions {
  return {
    event: EVENT_NAMES.APPLICATION_MODAL_OPENED,
    category: getIntroducerPortalCategoryfromLocale(locale),
    payload: {
      source: source,
    },
  };
}

/**
 * @deprecated
 */
export function getApplicationStartedEventDetails({
  source,
  productType,
  requestedAmount,
  locale,
}: {
  locale: string;
  source?: string;
  productType?: AvailableProducts;
  requestedAmount?: number;
}): TrackAmplitudeEventOptions {
  return {
    event: EVENT_NAMES.APPLICATION_STARTED,
    category: getIntroducerPortalCategoryfromLocale(locale),
    payload: {
      source: source,
      productType: productType,
      requestedAmount: requestedAmount,
    },
  };
}

/**
 * @deprecated
 */
export function getOfferAcceptedeventDetails({
  source,
  locale,
  productType,
  offeredAmount,
}: {
  source?: string;
  locale: string;
  productType?: AvailableProducts;
  offeredAmount?: number;
}): TrackAmplitudeEventOptions {
  return {
    event: EVENT_NAMES.APPLICATION_STARTED,
    category: getIntroducerPortalCategoryfromLocale(locale),
    payload: {
      source: source,
      productType: productType,
      offeredAmount: offeredAmount,
    },
  };
}

/**
 * @deprecated
 */
export function getDocumentUploadStartedEventDetails({
  documentCategory,
  locale,
}: {
  locale: string;
  documentCategory: DocumentType & DEDocumentType;
}): TrackAmplitudeEventOptions {
  return {
    event: EVENT_NAMES.DOCUMENT_UPLOAD_STARTED,
    category: getIntroducerPortalCategoryfromLocale(locale),

    payload: {
      documentCategory: documentCategory,
    },
  };
}

/**
 * @deprecated
 */
export function getNotificationShownEventDetails({
  locale,
}: {
  locale: string;
  type: string;
}): TrackAmplitudeEventOptions {
  return {
    event: EVENT_NAMES.NOTIFICATION_SHOWN,
    category: getIntroducerPortalCategoryfromLocale(locale),
  };
}

/**
 * @deprecated
 */
export function getNotificationCTAClickedDetails({
  CTAClicked,
  CTALocation,
  CTAText,
  locale,
}: {
  locale: string;
  CTAClicked: string;
  CTALocation: string;
  CTAText: string;
}): TrackAmplitudeEventOptions {
  return {
    event: EVENT_NAMES.NOTIFICATION_CTA_CLICKED,
    category: getIntroducerPortalCategoryfromLocale(locale),
    payload: {
      CTAClicked,
      CTAText,
      CTALocation,
    },
  };
}

/**
 * @deprecated
 */
export function introducerPortalEventCreator({
  event,
  locale,
  payload,
}: {
  event: string;
  locale: string;
  payload?: object;
}): TrackAmplitudeEventOptions {
  return {
    event: event,
    category: getIntroducerPortalCategoryfromLocale(locale),
    payload: {
      ...(payload || {}),
    },
  };
}

function getIntroducerPortalCategoryfromLocale(locale: string) {
  if (locale === 'de') return CATEGORY.INTRODUCER_PORTAL_DE;
  return CATEGORY.INTRODUCER_PORTAL;
}
function getIntroducerPortalSignupCategoryfromLocale(locale: string) {
  if (locale === 'de') return CATEGORY.INTRODUCER_SIGNUP_DE;
  return CATEGORY.INTRODUCER_SIGNUP;
}

/**
 * @deprecated
 */
export function getPageVisitedEvent() {
  return {
    category: CATEGORY.INTRODUCER_PORTAL,
    event: EVENT_NAMES.PAGE_VISITED,
  };
}
